module.exports = __webpack_public_path__ + "media/images/underline-green-c1e5f98acca2527cf46068a7e50b4ec3.svg";